import { useUser } from "~/modules/user/hooks/useUser";
import { FeatureNames } from "../flags";

// // // //

/**
 * useFeatureFlag
 * Utility hook for evaluating a PostHog feature flag
 * Returns a boolean indicating whether or not a specific feature is turned on
 * @param feature - the feature being checked as enabled / disabled
 */
export function useFeatureFlag(feature: FeatureNames): boolean {
    const { user } = useUser();
    return user.features[feature] || false;
}
